/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useLayoutSettings = () => {
  const data = useStaticQuery(graphql`
    {
      allWpPage(
        filter: { filterargument: { filterargument: { eq: "layout" } } }
      ) {
        nodes {
          id
          pageType {
            taxonomy
          }
          title
          language {
            slug
          }
          filterargument {
            filterargument
          }
          language {
            slug
          }
          layoutsettings {
            showpromotion
            carouselslides {
              fullscreenhero {
                fullslidecontent
                fullslideimagemobile {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
                fullslideimagedesktop {
                  node {
                    id
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
              heroHalf {
                slidecontenthalf
                slideheadinghalf
                halfstep1 {
                  steppromocontent
                  steppromotext
                }
                halfstep2 {
                  steppromocontent
                  steppromotext
                }
                halfstep3 {
                  steppromocontent
                  steppromotext
                }
                slideimagehalf {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return data.allWpPage.nodes
}
